import { requests } from './agentDialect';

export const fetchAllServices = () => requests.get(`/services`);